<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >区域湿度在线率
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @resetForm="handleResetForm"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.dateRange">
            <el-date-picker
              v-model="slotForms.forms.dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="datePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
          <el-form-item prop="forms.sceneType">
            <dict-select
              v-model="slotForms.forms.sceneType"
              placeholder="场景类型"
              :pkey="'scene_type'"
            ></dict-select>
          </el-form-item>
          <el-form-item prop="forms.monitorType" style="display: none">
            <dict-select
              v-model="slotForms.forms.monitorType"
              placeholder="监控类型"
              :pkey="'monitor_type'"
            ></dict-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <div style="width: 40%; float:left;">
      <section
        class="table-section"
        :style="{ height: resizeViewHeight + 'px' }"
      >
        <el-table
          v-loading="tableLoading"
          ref="multipleTable"
          border
          :data="tableData"
          height="100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            label="序号"
            align="center"
            type="index"
            width="55"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in localShowTableCols"
            :key="index"
            :show-overflow-tooltip="true"
            :prop="item.name"
            :label="item.title"
          ></el-table-column>
        </el-table>
      </section>
    </div>
    <!-- 表格 end -->

    <div style="width: 60%; float:right;">
      <!-- 曲线 -->
      <section :style="{ height: resizeViewHeight + 'px' }">
        <div
          :style="{ height: resizeViewHeight + 'px' }"
          style="width: 100%;height: 100%;margin: 10px"
          id="chartCurveDiv"
          ref="echartCurveDiv"
        ></div>
      </section>
    </div>

    <!-- 表格列设置 -->
    <!-- <e6-column-set
          @setColumnSubmit="handleSetColumnSubmit"
          @setColumnCancel="handleSetColumnCancel"
          :columSetVisible.sync="columSetVisible"
          :hideTableCols.sync="copyHideTableCols"
          :showTableCols.sync="copyShowTableCols"
        ></e6-column-set> -->
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import {
  FetchGetTableColumnSettings
  // FetchSaveUserTableColumnSettings
} from "_private/api/public.js";
import e6City from "e6city";
import { FetchFindMonitorReportAndChart } from "@/api/report/onlineRate";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
// import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { datePickerOptionsNotContainToday } from "@/utils/dateHasDisable.js";
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入曲线图组件
require("echarts/lib/chart/line");
// 引入title组件
require("echarts/lib/component/title");
// 引入title组件
require("echarts/lib/component/tooltip");
export default {
  components: {
    e6City
  },
  mixins: [resizeListener, operationManage],
  data() {
    return {
      tableLoading: false,
      total: 0,
      isSearch: false,
      formExtend: {
        forms: {
          dateRange: [],
          sceneType: "",
          // province: $GLOBAL_CONFIG.e6City.provinceName,
          province: "",
          // city: $GLOBAL_CONFIG.e6City.cityName,
          city: "",
          district: "",
          monitorType: 2
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      messageBoxVisible: false,
      //导出URL
      exportUrl: "/report/MonitorInfo/exportHumOnlineReport?",
      datePickerOptions: datePickerOptionsNotContainToday
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId", "organizations", "searchFormIsOpen"]),
    columnStr() {
      let columnStr = this.copyShowTableCols.map(item => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    }
  },
  mounted() {
    let _this = this;
    //初始化曲线图表
    this.$nextTick(function() {
      //初始化曲线图表
      this.chartCurve = echarts.init(this.$refs.echartCurveDiv);
    });
    window.addEventListener("resize", function() {
      _this.chartCurve.resize();
    });
  },
  created() {
    this.setSearchFormIsOpenAct();
    this.FetchStartAndEndtTime();
    this.FetchTableColumnDataAndTableData(
      { userId: this.userId, moduleId: this.moduleId },
      this.mergeObj()
    );
  },
  methods: {
    ...mapActions(["setOrganizationAct", "setSearchFormIsOpenAct"]),
    citySelect(res) {
      this.formExtend.forms.province = res.province.name;
      this.formExtend.forms.city = res.city.name;
      this.formExtend.forms.district = res.district.name;
    },
    /**
     * 给开始结束时间赋值
     */
    FetchStartAndEndtTime() {
      let queryTime = [];
      var date = new Date();
      var date1 = new Date(date - 1 * 24 * 3600 * 1000);
      var year = date1.getFullYear();
      var weak =
        date1.getMonth() + 1 < 10
          ? "0" + (date1.getMonth() + 1)
          : date1.getMonth() + 1;
      var day = date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate();
      var currentDate = year + "-" + weak + "-" + day;
      // var oneweekdate = new Date(date - 2 * 24 * 3600 * 1000);
      // var y = oneweekdate.getFullYear() + "-";
      // var m =
      //   (oneweekdate.getMonth() + 1 < 10
      //     ? "0" + (oneweekdate.getMonth() + 1)
      //     : oneweekdate.getMonth() + 1) + "-";
      // var d =
      //   oneweekdate.getDate() < 10
      //     ? "0" + oneweekdate.getDate()
      //     : oneweekdate.getDate();
      // var startDate = y + m + d;
      // queryTime.push(startDate);
      queryTime.push(currentDate);
      queryTime.push(currentDate);
      this.formExtend.forms.dateRange = queryTime;
    },

    //绘制曲线图
    drawLine(data) {
      let lineChartOption = {
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b} : {c} %"
        },
        xAxis: [
          {
            type: "category",
            data: data.lineData.map(item => {
              return item.areaName;
            }),
            axisLabel: {
              fontSize: 12,
              color: "#90939a",
              interval: 0
            },
            axisLine: {
              lineStyle: {
                color: "#e7eef6"
              },
              onZero: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#e7eef6"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            // name: "在线率（%）",
            axisLine: {
              lineStyle: {
                color: "#e7eef6"
              },
              onZero: true
            },
            axisLabel: {
              fontSize: 12,
              color: "#90939a",
              interval: 0
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#e7eef6"
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            type: "line",
            yAxisIndex: 0,
            data: data.lineData.map(item => {
              return item.onlineRate;
            }),

            color: "#fff",
            symbol: "circle",
            symbolSize: 6,
            smooth: true, //平滑曲线连接
            itemStyle: {
              normal: {
                color: "#2568ff"
              }
            },
            lineStyle: {
              color: {
                type: "radial",
                x: 0,
                y: 0,
                r: 5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#008afd" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#4446fb" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              width: 3
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#9bb5f8"
                  },
                  {
                    offset: 1,
                    color: "#fff"
                  }
                ])
              }
            }
          }
        ]
      };
      // 绘制图表
      this.chartCurve.setOption(lineChartOption);
      this.chartCurve.resize();
    },

    // 获取表格及图表数据
    FetchFindAreaHumOnline(data) {
      this.tableLoading = true;
      FetchFindMonitorReportAndChart(data)
        .then(response => {
          this.setChartData(response);
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.tableLoading = false;
        });
    },
    // 获取表格列列表
    // FetchGetTableColumnSettings(data) {
    //   this.tableLoading = true;
    //   FetchGetTableColumnSettings(data)
    //     .then(response => {
    //       this.setTableColumnData(response);
    //       this.tableLoading = false;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    // 修改表格列列表
    // FetchSaveUserTableColumnSettings(data) {
    //   FetchSaveUserTableColumnSettings(data)
    //     .then(response => {
    //       let type = response.code === 1 ? "success" : "error";
    //       let message = response.message;
    //       this.$message({
    //         showClose: true,
    //         message: message,
    //         type: type,
    //         duration: 2000,
    //         onClose: () => {
    //           if (type === "success") {
    //             this.FetchGetTableColumnSettings({
    //               moduleId: this.moduleId,
    //               userId: this.userId
    //             });
    //           }
    //         }
    //       });
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    // 获取表格列数据和表格数据
    FetchTableColumnDataAndTableData(tableColumnData, tableData) {
      this.tableLoading = true;
      Promise.all([
        FetchGetTableColumnSettings(tableColumnData),
        FetchFindMonitorReportAndChart(tableData)
      ])
        .then(([tableColumnResponse, tableChart]) => {
          tableColumnResponse = {
            code: 1,
            message: "OK",
            result: [
              {
                fixable: false,
                name: "areaName",
                show: true,
                title: "地区"
              },
              {
                fixable: false,
                name: "comparyNum",
                show: true,
                title: "企业数量"
              },
              {
                fixable: false,
                name: "onlineRate",
                show: true,
                title: "在线率(%)"
              }
            ]
          };
          // 设置表格数据
          this.setTableColumnData(tableColumnResponse);
          // 加载echarts
          this.setChartData(tableChart);
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 设置表格列数据
    setTableColumnData(response) {
      let showTableCols = [];
      let hideTableCols = [];
      if (response.result && Array.isArray(response.result)) {
        response.result.forEach(item => {
          if (item.show) {
            showTableCols.push(item);
          } else {
            hideTableCols.push(item);
          }
        });
      }
      this.showTableCols = showTableCols;
      this.hideTableCols = hideTableCols;
      this.copyShowTableCols = showTableCols;
      this.copyHideTableCols = hideTableCols;
      this.localShowTableCols = showTableCols;
    },
    setChartData(response) {
      if (response.result && response.result.lineData) {
        //绑定折线图
        this.drawLine(response.result);
        //this.tableData = this.filterTable(response.result.lineData);
        this.tableData = response.result.lineData;
      } else {
        this.$message({
          showClose: true,
          message: response.message,
          type: "error"
        });
      }
    },
    filterTable(list) {
      if (this.formExtend.forms.countyId === "") return list;
      return list.filter(item => {
        return item.dicId == this.formExtend.forms.countyId;
      });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        moduleId: this.moduleId,
        monitorType: 2
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
        this.$nextTick(() => {
          this.chartCurve.resize();
        });
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.FetchFindAreaHumOnline(this.mergeObj());
    },
    handleResetForm() {
      this.$refs["e6City"].clearCity();
      this.searchForm.provinceName = "";
      this.searchForm.cityName = "";
      this.searchForm.countyName = "";
      this.$refs.e6City.clearCity();
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    // handleSetColumnSubmit() {
    //   this.FetchSaveUserTableColumnSettings({
    //     moduleId: this.moduleId,
    //     userId: this.userId,
    //     columnStr: this.columnStr
    //   });
    // },

    // 导出
    handleExportClick() {
      let param = "";
      if (
        this.formExtend.forms.dateRange !== null &&
        this.formExtend.forms.dateRange !== ""
      ) {
        param += "&dateRange=" + this.formExtend.forms.dateRange;
        param += "&province=" + this.formExtend.forms.province;
        param += "&city=" + this.formExtend.forms.city;
        param += "&district=" + this.formExtend.forms.district;
        param += "&sceneType=" + this.formExtend.forms.sceneType;
        param += "&monitorType=" + this.formExtend.forms.monitorType;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "日期不能为空！",
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.e6-tree-wrapper {
  position: relative;
  .e6-tree {
    position: absolute;
    left: 0;
    right: 0;
    background-color: #fff;
    border: 1px solid #ccc;
    /deep/ .el-input__inner {
      border: {
        radius: 0;
        width: 0 0 1px 0;
      }
    }
    .e6-tree__contontent {
      max-height: 300px;
      min-height: 56px;
      width: 100%;
      overflow: auto;
    }
    /deep/ .el-tree {
      width: fit-content;
    }
  }
}
</style>
